import { format, formatDistance } from 'date-fns';

import { ar, enAU } from 'date-fns/locale';

export function formatDuration(noOfMinutes) {
  var num = noOfMinutes;
  var hours = (num / 60);
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);

  return rhours + 'س ' + rminutes + ' د';
}

export function formatHumanDuration(minutes) {
  if (minutes) return formatDistance(0, minutes * 60 * 1000, { locale: ar });
}

export function getHumanDuration(date, baseDate) {
  return formatDistance(date, baseDate, { locale: ar });
}

export function formatTime(date) {
  return format(new Date(date), 'hh:mma', { locale: enAU });
}

export function formatFullDate(date) {
  return format(new Date(date), 'EEEE dd LLLL yyyy', { locale: ar });
}

export function shortDate(date) {
  return format(new Date(date), 'LLL dd');
}

export function formatDate(date, locale = 'ar') {
  return format(new Date(date), 'yyyy-MM-dd', { locale: locale === 'en' ? enAU : ar });
}

export function getMonth(date) {
  return format(new Date(date), 'MMMM', { locale: ar });
}

export function getYear(date) {
  return format(new Date(date), 'yyyy', { locale: ar });
}

export function getDay(date) {
  // return format(new Date(date), 'dd', { locale: ar });
  return date;
}

export function toDate() {

}
